export const numberFormatter = (num, digits = 1) => {
  const lookup = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "k" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "G" },
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" },
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;

  const item = lookup
    .slice()
    .reverse()
    .find((item) => num >= item.value);

  return item
    ? `$${(num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol}`
    : "";
};

export const mapTypeToNumber = (goal) => {
  switch (goal) {
    case "Retirement":
      return 1;
    case "Major Purchase":
      return 2;
    case "Education":
      return 3;
    case "Build Wealth":
      return 4;
    default:
      return 0;
  }
};

export const mapNumberToType = (goal) => {
  switch (goal) {
    case 1:
      return "Retirement";
    case 2:
      return "Major Purchase";
    case 3:
      return "Education";
    case 4:
      return "Build Wealth";
    default:
      return 0;
  }
};

export const getGoalPathFromNumber = (goalNumber) => {
  switch (goalNumber) {
    case 1:
      return "/retirement";
    case 2:
      return "/major_purchase";
    case 3:
      return "/education";
    case 4:
      return "/build_wealth";
    default:
      return "/";
  }
};

export const mapNumberToRiskProfile = (number) => {
  switch (number) {
    case 1:
      return "Very Conservative";
    case 2:
      return "Conservative";
    case 3:
      return "Balanced";
    case 4:
      return "Adventurous";
    case 5:
      return "Very Adventurous";
    default:
      return "";
  }
};

export const validateField = (min, max, value) => {
  if (!value || value < min || value > max)
    return `Value must be between ${min} and ${max}`;
  return "";
};

export const createPayload = (
  dashboardData,
  advisorPreference,
  email,
  goal
) => {
  const monthlyContribution = dashboardData?.settings?.additionalInfos.filter(
    (data) => data.subject === "Monthly Contribution"
  );

  const yearsRemaining = dashboardData?.settings?.additionalInfos.filter(
    (data) =>
      data.subject === "Years Remaining" || data.subject === "Years Shown"
  );

  const strategy = dashboardData?.strategies.filter(
    (data) => data.isSelected === true
  );

  let recommendedPortfolio = "";
  dashboardData?.recommendedPortfolios?.portfolios.forEach((data) => {
    recommendedPortfolio =
      recommendedPortfolio +
      data.name +
      " " +
      data.allocation.toFixed(2) +
      "\n";
  });

  const retirementIncomeGoal = dashboardData?.settings?.additionalInfos.filter(
    (data) => data.subject === "Retirement Income Goal"
  );
  return {
    goalId: goal?.id,
    advisorPreference: advisorPreference, //if user press yes checkbox then null, if no mail id then - the selected checkbox label
    advisor: email, // no email should be "" or null
    strategy: strategy?.length > 0 ? strategy[0].name : "", //check with the key isSelectedTrue in strategies array
    recommendedPortfolio: recommendedPortfolio, //recommendedPortfolios.portfolios array loop the array and create a string like - name+" "+2 decimal points round(allocation)+"%"\n
    accountBalance:
      dashboardData?.projectedPortfolio?.estimatedBalance.toString() || "0",
    strongMarketReturn:
      dashboardData?.projectedPortfolio?.strongMarketReturn.toString() || "0",
    weakMarketReturn:
      dashboardData?.projectedPortfolio?.weekMarketReturn.toString() || "0",
    maxDrawdown:
      dashboardData?.projectedPortfolio?.maxDrawdown.toString() || "0",
    timeHorizon:
      dashboardData?.dashboardGraphInformation?.lenght.toString() || 0, // settings.additionalInfos.subject === "Years Remaining" get value
    monthlyContribution:
      monthlyContribution?.length > 0
        ? monthlyContribution[0].value.toString()
        : "0",
    yearsRemaining:
      yearsRemaining?.length > 0 ? yearsRemaining[0].value.toString() : "0",
    retirementIncomeGoal:
      retirementIncomeGoal?.length > 0
        ? retirementIncomeGoal[0].value.toString()
        : "0", //dashboardData?.settings?.additionalInfos.filte with emma tbd
  };
};
